module.exports = __webpack_public_path__ + "static/media/PG-Logotype-Primary-White.0d072752.svg";